import React from 'react';

function MapTrifold(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none" {...props}>
      <path
        d="M8.75 15.8125L3.25 17.1875V4.8125L8.75 3.4375"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 18.5625L8.75 15.8125V3.4375L14.25 6.1875V18.5625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 6.1875L19.75 4.8125V17.1875L14.25 18.5625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MapTrifold;
